<template>
  <div class="footer">
    <v-footer color="footer-color" class="pt-0">
      <v-container class="pt-0">
        <v-row justify="center">
          <v-col cols="12" md="4">
            <v-card-text class="white--text">
              <strong class="text-h4 font-weight-bold">Beckton College</strong>
              <p class="text-h6 mt-4">
                Studying at Beckton College will provide you with the tools
                you need to forge a bright future for yourself. With experience
                in helping students achieve their potential, we are committed to
                excellence in learning and teaching.
              </p>
            </v-card-text>
            <v-card-text class="white--text">
              <p>Follow Us</p>
              <v-btn
                v-for="icon in icons"
                :key="icon.icon"
                :href="icon.url"
                class="ma-1 white--text"
                icon
                target="_blank"
              >
                <v-icon :color="icon.color">
                  {{ icon.icon }}
                </v-icon>
              </v-btn>
            </v-card-text>
            <v-card-text class="white--text" v-if="$vuetify.breakpoint.lgAndUp">
              <strong>Beckton College | &copy;All rights reserved.</strong>
              <br><br>
              <div class="text-sz font-weight-thin black--text">
                Logo generated by
                <a href="https://www.designevo.com/logo-maker/" class="links black--text" title="Free Online Logo Maker">
                  DesignEvo free logo designer
                </a>
              </div>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="4" class="pa-0 ma-0">
            <div v-if="$vuetify.breakpoint.smAndDown">
            </div>
             <div v-else-if="$vuetify.breakpoint.mdOnly" class="college-name-md ma-auto">
              <v-img
                eager
                src="../assets/logo-test.png"
                height="15vh"
                width="20vh"
                contain
              ></v-img>
            </div>
            <div v-else-if="$vuetify.breakpoint.lgAndUp" class="college-name ma-auto">
              <v-img
                eager src="../assets/logo-test.png"
                height="30vh"
                width="35vh"
                contain>
              </v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-text class="white--text">
              <strong class="text-h4 font-weight-bold mb-4">Quick Links</strong>
              <a
                v-for="button in buttons"
                :key="button.label"
                :href="button.url"
                class="links"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ button.label }}</v-list-item-title>
                </v-list-item-content>
              </a>
            </v-card-text>
            <v-card-text class="white--text" v-if="$vuetify.breakpoint.mdAndDown">
              <div class="text-sz font-weight-thin black--text">
                Logo generated by
                <a href="https://www.designevo.com/logo-maker/" class="links black--text" title="Free Online Logo Maker">
                  <b>DesignEvo free logo designer</b>
                </a>
              </div>
              <br>
              <strong>Beckton College | &copy;All rights reserved.</strong>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      icons: [
        {
          icon: 'fab fa-facebook',
          url: '',
          color: '#3b5998',
        },
        {
          icon: 'fab fa-twitter',
          url: '',
          color: '#00acee',
        },
        {
          icon: 'fab fa-linkedin',
          url: '',
          color: '#0e76a8',
        },
        {
          icon: 'fab fa-instagram',
          url: '',
          color: '#E1306C',
        },
        {
          icon: 'fab fa-youtube',
          url: '',
          color: '#c4302b',
        },
      ],
      buttons: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: 'About Us',
          url: '/about',
        },
        {
          label: 'Campus',
          url: '/campus',
        },
        {
          label: 'Courses',
          url: '/programmes',
        },
        {
          label: 'Events',
          url: '/events',
        },
        {
          label: 'Contact',
          url: '/contact',
        },
        {
          label: 'Apply Now',
          url: '/apply',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.links {
  text-decoration: none;
  color: white;
}

a:hover {
  color: green;
}

.footer-color {
  background-color: #1b1b1b !important;
}

.text-sz {
  font-size: 9px;
}

.college-name {
  clip-path: polygon(0% 0%, 100% 0, 100% 60%, 50% 100%, 0 60%);
  position: relative;
  top: -0px;
  background-color: #e0e0e0;
  width: 35vh !important;
  height: 35vh !important;
}

.college-name-md {
  clip-path: polygon(0% 0%, 100% 0, 100% 60%, 50% 100%, 0 60%);
  position: relative;
  top: -0px;
  background-color: #e0e0e0;
  width: 20vh !important;
  height: 20vh !important;
}

</style>
